<template>

    <div v-if="!addressInUse" class="modal-header bg-light">
        <h5 class="modal-title" id="modalTitle">{{ $i18n('LABEL_CONFIRM_DELETE') }}</h5>
        <button type="button" @click="cancel()" class="btn-close" :aria-label="$i18n('LABEL_CLOSE')"></button>
    </div>

    <div class="modal-body">

        <form 
            v-if="!addressInUse"
            id="registrationForm"
            action="api/register" 
            method="post" 
            class="mb-3" 
            @submit="deleteBillingAddress($event)">

            <Text id="TEXT_DELETE_BILLING_ADDRESS_CONFIRM" />

        </form>

        <Text v-if="addressInUse" id="TEXT_BILLING_ADDRESS_IN_USE" />

    </div> <!-- /.modal-body -->

    <div class="modal-footer">
        <button v-if="addressInUse" type="button" @click="cancel()" class="btn btn-secondary">{{ $i18n('LABEL_CLOSE') }}</button>
        <button v-if="!addressInUse" type="button" @click="cancel()" class="btn btn-secondary me-2">{{ $i18n('LABEL_CANCEL') }}</button>
        <button v-if="!addressInUse" type="button" @click="deleteBillingAddress()"  class="btn btn-danger">{{ $i18n('LABEL_DELETE') }}</button>
    </div>

</template>

<script>
import axios from 'axios';
import store from '../store/store.js';
import Text from '../components/Text.vue';

export default {
    name: 'DeleteBillingAddressForm',
    components: {
        Text
    },
    props: {
        id: Number,
        userId: Number
    },
    computed: {
        addressInUse() {
            return store.state.subscriptions.find(item => item.billingAddressId == this.id);
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        cancel() {
            store.commit('setModal', null);
        },
        /**
         * Deletes a billing address from the DB permanently.
         */
        deleteBillingAddress() {
            store.commit('setLoading', true);
            store.commit('setLoadingStatus', 'Deleting billing address');

            axios({
                method: 'delete',
                url: '/api/billing-address/' + this.id,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .then((response) => {
                if (response.data.status == 'SUCCESS') {
                    if (response.data.messages) {
                        this.$addToastMessage(response.data.messages);
                    }
                } else if (response.data.errors) {
                    store.commit('setModalErrors', response.data.errors);
                }
            })
            .catch((error) => {
                store.commit('addModalError', this.$i18n('TEXT_ERROR_GENERAL'));
                console.error(error);
            })
            .then(() => {
                store.commit('setLoading', false);
                store.commit('setModal', null);
                this.$emitter.emit('getBillingAddresses');
            });
        }
    }
}
</script>

<style scoped>

</style>
